import moment from 'moment';
import '../lib/daterangepicker.js';

class DatePickerController {
  constructor($scope, RouterService, $rootScope) {
    let DP_LOCALES = {
      'ru': {
        applyLabel : 'ОК',
        cancelLabel: 'Отмена',
        fromLabel  : 'С',
        toLabel    : 'по',
        weekLabel  : 'нед',
        format     : 'DD/MM/YYYY',
      },
      'en': {},
    };
    let dp_locale = DP_LOCALES[window.selectedLang] ? DP_LOCALES[window.selectedLang] : DP_LOCALES['en'];

    let picker = $('#reportrange').daterangepicker({
      startDate          : moment(this.timeFrom),
      endDate            : moment(this.timeTo),
      minDate            : moment().year(2000),
      // dateLimit          : {days: 365},
      showDropdowns      : false,
      showWeekNumbers    : true,
      timePicker         : false,
      timePickerIncrement: 1,
      timePicker24Hour   : true,
      ranges             : {
        'Сегодня'       : [moment().startOf('day'), moment().endOf('day')],
        'Вчера'         : [
          moment().startOf('day').subtract(1, 'days'), moment()
            .endOf('day')
            .subtract(1, 'days'),
        ],
        '7 дней'        : [
          moment().startOf('day').subtract(6, 'days'), moment()
            .endOf('day'),
        ],
        '30 дней'       : [
          moment()
            .startOf('day')
            .subtract(29, 'days'), moment()
            .endOf('day'),
        ],
        'Текущая неделя': [moment().startOf('week'), moment().endOf('week')],
        'Текущий месяц' : [moment().startOf('month'), moment().endOf('month')],
        'Текущий год'   : [moment().startOf('year'), moment().endOf('year')],
      },
      opens              : 'right',
      drops              : 'down',
      alwaysShowCalendars: true,
      linkedCalendars    : true,
      buttonClasses      : ['btn', 'btn-lg'],
      separator          : ' to ',
      timeZone           : 0,
      locale             : dp_locale,
      autoApply          : true,
    }, (start, end, label) => {
      RouterService.timeFrom = this.timeFrom = start.toDate();
      RouterService.timeTo = this.timeTo = end.toDate();
      $rootScope.$digest();
    })
      .data('daterangepicker');

    $scope.$watch('$ctrl.timeFrom', (newValue) => {
      picker.setStartDate(newValue);
    });
    $scope.$watch('$ctrl.timeTo', (newValue) => {
      picker.setEndDate(newValue);
    });
  }
}

export const DatePickerComponent = {
  template  : require('./date-picker.component.html'),
  controller: DatePickerController,
  bindings  : {
    timeFrom: '=',
    timeTo  : '=',
  },
};




// WEBPACK FOOTER //
// ./src/filter/date-picker.component.js